// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingsDetails_wrapper__1m0MF","header":"SettingsDetails_header__11jVT","card":"SettingsDetails_card__2SiMJ"};